/** @format */

import React from 'react';

import {GridSelect} from '@sttark/design-system';

import {
    FORM_FACTOR_HAND_APPLIED,
    FORM_FACTOR_ROLLS,
    ROLL_DIRECTION_BOTTOM,
    ROLL_DIRECTION_LEFT,
    ROLL_DIRECTION_RIGHT,
    ROLL_DIRECTION_TOP
} from 'frontier-constants';

import applicationMachine from './assets/application-machine.svg';
import applicationHand from './assets/application-hand.svg';
import rollDirectionTop from './assets/roll-direction-top.svg';
import rollDirectionBottom from './assets/roll-direction-bottom.svg';
import rollDirectionLeft from './assets/roll-direction-left.svg';
import rollDirectionRight from './assets/roll-direction-right.svg';

export default function ApplicationSelect({value, onChange, rollDirection, onRollDirectionChange}) {
    const handleFormFactorChange = v => {
        onChange(v);
        // Default the roll direction if empty
        if (v === FORM_FACTOR_ROLLS && !rollDirection) {
            onRollDirectionChange(ROLL_DIRECTION_TOP);
        }
    };

    return (
        <>
            <GridSelect
                options={[
                    {
                        label: 'Machine Applied (Rolls)',
                        value: FORM_FACTOR_ROLLS,
                        image: applicationMachine
                    },
                    {
                        label: 'Hand Applied (Rolls)',
                        value: FORM_FACTOR_HAND_APPLIED,
                        image: applicationHand
                    }
                ]}
                value={value}
                onChange={handleFormFactorChange}
                mobileCols={1}
            />
            {value === FORM_FACTOR_ROLLS && (
                <GridSelect
                    options={[
                        {
                            label: 'Top Edge Leading',
                            value: ROLL_DIRECTION_TOP,
                            image: rollDirectionTop
                        },
                        {
                            label: 'Bottom Edge Leading',
                            value: ROLL_DIRECTION_BOTTOM,
                            image: rollDirectionBottom
                        },
                        {
                            label: 'Right Edge Leading',
                            value: ROLL_DIRECTION_RIGHT,
                            image: rollDirectionRight
                        },
                        {
                            label: 'Left Edge Leading',
                            value: ROLL_DIRECTION_LEFT,
                            image: rollDirectionLeft
                        }
                    ]}
                    value={rollDirection}
                    onChange={onRollDirectionChange}
                />
            )}
        </>
    );
}
